// extracted by mini-css-extract-plugin
module.exports = {"card":"styles-module--card--23dHk","icon":"styles-module--icon--2g53S","info":"styles-module--info--3S02p"};